import { INTRO_CONSTANTS } from "./constants";
import { Heading, Stack, Text } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { useTextVariants } from "@/theme/components/useSectionHeading";

const IntroComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={8} justify={"center"}>
      <Heading as="h2" fontWeight={"400"} fontSize={"40px"} textAlign={"center"}>
        {INTRO_CONSTANTS.title}
      </Heading>
      <Balancer>
        <Text
          px={6}
          variant={TextVariant}
          color="text.100"
          textAlign={"center"}
          lineHeight={"30px"}
        >
          {INTRO_CONSTANTS.text}
        </Text>
      </Balancer>
    </Stack>
  );
};

export default IntroComponent;
